module.exports = __webpack_public_path__ + "media/images/down-arrow-a5e85e8768cfcdeb81f67ef72ed66482.svg";